<template>
	<div>    
		<v-content>      
			<v-container fluid>        
              <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="transportMatrix == ''" /></center>  
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field append-icon="search" v-if="transportMatrix != '' && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field v-if="transportMatrix != '' && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>                    
              </v-flex>				
				<v-data-table :headers="headers" v-if="transportMatrix != ''" :search="search" :items="transportMatrix.tcmItems" class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
                        <td width="35%" class="text-xs-right"><v-select :items="transportMatrix.products" label="Product" v-model="props.item.product_code" autocomplete solo item-value="id"></v-select></td>      
						<td width="15%" class="text-xs-right"><v-select :items="transportMatrix.uom" label="UOM" autocomplete v-model="props.item.uom" solo item-text="name" item-value="id"></v-select></td>
                        <td width="remainingWidth" class="text-xs-right matrixTd" v-for="radius in radiusLength"><v-text-field required solo v-model="props.item.radius_cost[parseInt(radius)-1]"></v-text-field></td>                        						
                      <td width="5%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncDeleteMatrix(props.item.product_code)"><i class="material-icons">delete_forever</i></a></td>
					</template>
				</v-data-table>
			</v-container>
		</v-content>		
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';  

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {	
            search: '',
            radiusLength: 0,
            headers: [],
            remainingWidth: '5%'
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
      },
      fncDeleteMatrix(productCode) {
        this.$store.commit({
          type: 'fncDeleteMatrix',
          id: productCode
        })
      }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'transportMatrix',
			'globalModalParams'
		])
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateMatrix');	      
    },
    watch: {
      transportMatrix() {
        this.headers = [];
        this.radiusLength = 0;
        this.headers.push({ text: 'Product', value: 'name', width: '35%' });
        this.headers.push({ text: 'UOM', value: 'short_name', width: '15%' });    
        var remainingWidth = 45 / parseInt(this.transportMatrix.structure.length);
        this.remainingWidth = remainingWidth + '% ';
        for (var k in this.transportMatrix.structure) {
          this.radiusLength++;
          this.headers.push({ text: this.transportMatrix.structure[k].radius+'km', value: this.transportMatrix.structure[k].id, width: remainingWidth + '%' });          
        }
        this.headers.push({ text: 'Delete', value: 'delete', width: '5%' });
      }
    }
   
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>